import React from 'react';

const STATS = [
  { number: '8',    label: 'Countries supported' },
  { number: '100+', label: 'Statutory parameters modelled' },
  { number: '< 2s', label: 'Time to full cost breakdown' },
  { number: '2',    label: 'Export formats' },
];

export default function About() {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about-inner">
          <div className="about-text">
            <div className="section-label">About</div>
            <h2 className="section-title about-title">Built by people who've lived the problem</h2>
            <p>
              Quoteology was built by a team with deep roots in global staffing and workforce solutions.
              We spent years watching firms lose mandates or erode margins because their contractor cost
              quotes were built on estimates, stale spreadsheets, or flat-rate assumptions.
            </p>
            <p>
              We built Quoteology to solve that — a platform that treats every country's tax code with
              the same rigour a local accountant would, and puts the output in a format your clients
              can act on immediately.
            </p>
            <p>
              Our engine is built from official government sources. Rates are configurable by your team
              without developer involvement. Outputs are export-ready in seconds.
            </p>
            <a href="#contact" className="btn-primary">Get in touch</a>
          </div>
          <div className="about-stats">
            {STATS.map(s => (
              <div className="stat-block" key={s.label}>
                <span className="stat-number">{s.number}</span>
                <span className="stat-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
